// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { List, Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetMarkets (params?: {}): Promise<List>;
    publicGetMarketsMarketIdTicker (params?: {}): Promise<Dict>;
    publicGetMarketsMarketIdTrades (params?: {}): Promise<List>;
    publicGetMarketsMarketIdOrderbook (params?: {}): Promise<Dict>;
    publicGetMarketsMarketIdCandles (params?: {}): Promise<List>;
    publicGetMarketsTickers (params?: {}): Promise<List>;
    publicGetMarketsOrderbooks (params?: {}): Promise<List>;
    publicGetTime (params?: {}): Promise<Dict>;
    privateGetOrders (params?: {}): Promise<List>;
    privateGetOrdersId (params?: {}): Promise<Dict>;
    privateGetBatchordersIds (params?: {}): Promise<Dict>;
    privateGetTrades (params?: {}): Promise<List>;
    privateGetTradesId (params?: {}): Promise<Dict>;
    privateGetWithdrawals (params?: {}): Promise<List>;
    privateGetWithdrawalsId (params?: {}): Promise<Dict>;
    privateGetDeposits (params?: {}): Promise<List>;
    privateGetDepositsId (params?: {}): Promise<Dict>;
    privateGetTransfers (params?: {}): Promise<List>;
    privateGetTransfersId (params?: {}): Promise<Dict>;
    privateGetAddresses (params?: {}): Promise<Dict>;
    privateGetWithdrawalFees (params?: {}): Promise<List>;
    privateGetAssets (params?: {}): Promise<List>;
    privateGetAccountsMeTradingFees (params?: {}): Promise<Dict>;
    privateGetAccountsMeWithdrawalLimits (params?: {}): Promise<List>;
    privateGetAccountsMeBalances (params?: {}): Promise<Dict>;
    privateGetAccountsMeTransactions (params?: {}): Promise<List>;
    privateGetReportsId (params?: {}): Promise<Dict>;
    privatePostOrders (params?: {}): Promise<Dict>;
    privatePostBatchorders (params?: {}): Promise<Dict>;
    privatePostWithdrawals (params?: {}): Promise<Dict>;
    privatePostReports (params?: {}): Promise<Dict>;
    privateDeleteOrders (params?: {}): Promise<List>;
    privateDeleteOrdersId (params?: {}): Promise<Dict>;
    privateDeleteBatchordersIds (params?: {}): Promise<Dict>;
    privatePutOrdersId (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
